<template>
  <div class="quick-event">

    <h1>Make your selection</h1>

    <div class="filter-tile rounded" v-if="completed.includes('tg')">
      {{filterParams.targetGroup}}
      <button @click="step = 'tg'"><i class="material-icons">edit</i></button>
    </div>
    <section v-if="step == 'tg'">
      <h2>Target group</h2>
      <p>Pick your target group</p>
      <SelectTargetGroup v-model="filterParams.targetGroup" :group="filterParams.targetGroup" />

      <div class="button-container">
        <button 
          @click="completeStep('tg')" 
          :disabled="!filterParams.targetGroup"
          class="btn large">
            <span>Next</span> <i class="material-icons">arrow_forward</i>
        </button>
      </div>
    </section>

    <div class="filter-tile rounded" v-if="completed.includes('ta')">
      {{filterParams.timeValue}} minutes
      <button @click="step = 'ta'"><i class="material-icons">edit</i></button>
    </div>
    <section v-if="step == 'ta'">
      <h2>Time available</h2>
      <p>Slide the selector to choose duration</p>
      <Gauge v-model="filterParams.timeValue"  />

      <div class="button-container">
        <button 
          @click="completeStep('ta')" 
          :disabled="!filterParams.targetGroup"
          class="btn large">
            <span>Next</span> <i class="material-icons">arrow_forward</i>
        </button>
      </div>
    </section>

    <div class="filter-tile rounded" v-if="completed.includes('topic')">
      {{filterParams.topic}}
      <button @click="step = 'topic'"><i class="material-icons">edit</i></button>
    </div>
    <section v-if="step == 'topic'">
      <h2>Topic</h2>
      <p>Pick the topic</p>
      <TopicPicker v-model="filterParams.topic" :topics="topics" @picked="completeStep('topic')"  />
    </section>

    <div class="button-container" v-if="readyToSearch">
      <button 
        @click="searchScenario" 
        class="btn large">
          <span>Select Playlist</span> <i class="material-icons">arrow_forward</i>
      </button>
    </div>
    
  </div>
</template>

<script>
import SelectTargetGroup from '@/components/SelectTargetGroup.vue'
import Gauge from '@/components/Gauge.vue'
import TopicPicker from '@/components/TopicPicker.vue'
export default {
  name: "QuickEvent",
  components: {
    Gauge,
    SelectTargetGroup,
    TopicPicker
  },
  data () {
    return {
      step: "tg",
      completed: [],
      filterParams: {
        targetGroup: null,
        timeValue: 5,
        topic: null,
      },
      topics: [
        "Pyro Product Knowledge",
        "Situation And Risk Assessment",
        "Means",
        "Movement",
        "Removal",
        "Extinguishing",
        "Storage",
        "Seizure",
        "Prevention Tactics"
      ]
    }
  },
  computed: {
    readyToSearch () {
      return (this.filterParams.targetGroup !== null && this.filterParams.topic !== null && this.step == 'overview' )
    }
  },
  created () {    
    this.filterParams =  this.$store.state.scenarioSearch.filterParams

    if (this.filterParams.targetGroup) {
      this.completed.push('tg')
      this.step = 'overview'
    }
    if (this.filterParams.timeValue) {
      this.completed.push('ta')
    }
    if (this.filterParams.topic) {
      this.completed.push('topic')
    }
  },
  methods: {
    searchScenario () {
      this.$store.dispatch('scenarioSearch/set', this.filterParams).then(() => {
        this.$router.push('/search-results/')
      })
    },
    completeStep(step) {
      if (step == 'tg') {
        this.completed.push('tg')
        if(!this.completed.includes('ta')) {
          this.step = 'ta'
        } else {
          this.step = 'overview'
        }
      } else if (step == 'ta') {
        this.completed.push('ta')
        if(!this.completed.includes('topic')) {
          this.step = 'topic'
        } else {
          this.step = 'overview'
        }
      } else if (step == 'topic') {
        this.completed.push('topic')
        this.step = 'overview'
      }
    }
  }
}


</script>

<style lang="scss" scoped>
.quick-event {
  max-width: var(--container-width);
  margin: 0 auto;
}

h1 {
  font-size: 24px;
  color: #3D3DDE;
  margin: 0 15px 15px;
  padding-bottom: 15px;
  border-bottom: 2px solid #E2E8FF;
}

.filter-tile {
  background-color: #E2E8FF;
  color: #3D3DDE;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 10px 10px;
  padding: 12px 15px;

  i {
    color: #3D3DDE;
  }
}

section {
  color: #3D3DDE;
  padding: 15px;

  h2 {
    font-size: 24px;
    color: #3D3DDE;
  }
  p {
    margin-bottom: 1.5em;
    font-size: 12px;
    color: #3D3DDE;
  }
}

.button-container {
  margin: 0 -15px;
  position: sticky;
  bottom: 0;
  z-index: 10;

  @media all and (min-width: 768px) {
    margin: 0;
  }
}
</style>